var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaptopicon24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "laptop_icon-24",
    "data-name": "laptop icon-24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7148",
    "data-name": "Rectangle 7148",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_794",
    "data-name": "Group 794",
    transform: "translate(-0.034 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    "data-name": "Path 822",
    d: "M26.169,9H21.151A2.112,2.112,0,0,0,19,11.151V21.9a2.112,2.112,0,0,0,2.151,2.151h5.018A2.112,2.112,0,0,0,28.32,21.9V11.151A2.112,2.112,0,0,0,26.169,9ZM24.735,21.9H22.585a.717.717,0,0,1,0-1.434h2.151a.717.717,0,0,1,0,1.434Zm2.151-3.585H20.434V11.151a.677.677,0,0,1,.717-.717h5.018a.677.677,0,0,1,.717.717Z",
    transform: "translate(-5.369 -1.132)",
    fill: "#adb5b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    "data-name": "Path 823",
    d: "M12.2,14.32h-8.6V6.434H17.933V5.717A.677.677,0,0,0,17.216,5H2.877a.677.677,0,0,0-.717.717v8.6a.627.627,0,0,0-.645.43L.081,18.335a.674.674,0,0,0,.072.645c.143.143.358.358.574.358H12.2Z",
    fill: "#adb5b9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopicon24);
export default __webpack_public_path__ + "static/media/laptop icon-24.6344e718360674a14719c053f893afdf.svg";
export { ForwardRef as ReactComponent };